import request from 'request-promise';

const api =
{
	call: (endpoint, data) =>
	{	//2017-08-07
		var url = '/webservice/'+endpoint;
		
		return request.postURL(url, data);
	},
	cart:
	{
		add: (productID, quantity) =>
		{	//2017-08-07
			quantity = quantity || 1;
			
			return api.call('Cart/add', {productID:productID,quantity:quantity});
		},
		remove: (productID) =>
		{	//2017-08-07
			return api.call('Cart/removeItem', {productID:productID});
		},
		empty: () =>
		{	//2017-08-07
			return api.call('Cart/removeAll');
		},
		setQuantity: (productID, quantity) =>
		{	//2017-08-07
			return api.call('Cart/setQuantity', {productID:productID,quantity:quantity});
		},
		updateQuantities: (products) =>
		{	//2017-09-05
			return api.call('Cart/updateQuantities', {products:products});
		},
		getItems: () =>
		{	//2017-08-07
			return api.call('Cart/getItems');
		},
		getItemCount: (unique) =>
		{	//2017-08-08
			unique = !!unique;
			
			return api.call('Cart/getItemCount', {unique:unique});
		},
		getProducts: (format) =>
		{	//2017-08-09
			format = !!format;
			
			return api.call('Cart/getProducts', {format:format});
		},
		getProductTotal: () =>
		{	//2017-08-09
			return api.call('Cart/getProductTotal');
		},
		getDatalayerProducts: () =>
		{	//2020-04-28
			return api.call('Cart/getDatalayerProducts');
		}
	},
	discountCode:
	{
		add: (discountCode) =>
		{	//2017-09-05
			return api.call('DiscountCode/add', {discountCode:discountCode});
		},
		remove: () =>
		{	//2017-09-05
			return api.call('DiscountCode/remove');
		}
	},
	contentBlock:
	{
		getByID: (contentBlockID) =>
		{	//2017-09-07
			return api.call('ContentBlock/getByID', {contentBlockID:contentBlockID});
		}
	},
	customer:
	{
		getData: () =>
		{
			return api.call('Customer/getData');
		},
		toggleFavoriteProduct: (productID) =>
		{
			return api.call('Customer/toggleFavoriteProduct', { productID:productID });
		}
	},
	newsletter:
	{
		subscribe: (email, recaptchaToken) =>
		{	//2017-08-08
			return api.call('Newsletter/subscribe', {email:email, recaptchaToken:recaptchaToken});
		},
		
		unsubscribe: (email) =>
		{	//2017-08-08
			return api.call('Newsletter/unsubscribe', {email:email});
		}
	},
	order:
	{
		cancel: (orderID) =>
		{
			return api.call('Order/cancel', {orderID:orderID});
		}
	},
	session:
	{
		applyBonus: (apply) =>
		{	//2017-09-05
			apply = (!!apply).toString();
			
			return api.call('Session/applyBonus', {apply:apply});
		},
		setCharity: (charityID) =>
		{	//2021-03-31
			return api.call('Session/setCharity', {charityID: charityID});
		},
		becomeMember: (yes) =>
		{	//2017-09-05
			yes = (!!yes).toString();
			
			return api.call('Session/becomeMember', {do:yes});
		},
		login: async fields =>
		{	//2017-09-05
			return api.call('Session/login', fields);
		},
		logout: () =>
		{	//2017-09-05
			return api.call('Session/logout');
		}
	},
	contentTranslation:
	{
		translateText: (text) =>
		{
			text ??= '';
			return api.call('ContentTranslation/translateText', {text});
		},
		updateChosenTranslationOption: (translator, options) =>
		{
			return api.call('ContentTranslation/updateChosenTranslationOption', {translator, options});
		},
		getTranslationOptionsHTML: () =>
		{
			return api.call('ContentTranslation/getTranslationOptionsHTML');
		},
		getTranslationOptions: () =>
		{
			return api.call('ContentTranslation/getTranslationOptions');
		},
		setChosenTranslationOptions: (options) =>
		{
			return api.call('ContentTranslation/setChosenTranslationOptions', {options});
		},
		updateGlossaryList: (languages) =>
		{
			return api.call('ContentTranslation/updateGlossaryList', {languages});
		},
		suggestTranslation: (options) =>
		{
			return api.call('ContentTranslation/suggestTranslation', {options});
		},
	}
};

export default api;
